import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/noData.png';
const _withScopeId = n => (_pushScopeId("data-v-64a77328"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  style: {
    "padding": "100px 0",
    "text-align": "center"
  }
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
})], -1));
const _hoisted_3 = {
  class: "q-mt-lg"
};
export default {
  __name: 'index',
  props: {
    message: {
      type: String,
      default: ""
    }
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", null, [_createElementVNode("span", _hoisted_3, _toDisplayString(props.message || _ctx.$t("common.noData")), 1)])]);
    };
  }
};